import React from "react"


export default function GroupOption({ groupOption, selected, onClick }) {
  return (
    <div
      onClick={ onClick }
      className={ `custom-multi-select-option ${ selected && "selected" }` }
    >
      { groupOption.name }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/TrainingContainer/AssignToGroupModal/GroupOption.js